import React from "react";
import { SectionHeading } from "@/components/common/SectionHeading";
import { Reveal } from "@/components/common/Reveal";
import { LeadForm } from "@/components/forms/LeadForm";

/**
 * Reusable enquiry/quote section for product pages (id="quote").
 * Pre-selects the relevant service in the lead form.
 */
export const QuoteSection = ({
  service,
  eyebrow = "Get a Quote",
  title = "Request Pricing",
  subtitle = "Share a few details and our team will get back to you with pricing tailored to your requirements.",
  testIdPrefix = "quote",
}) => {
  return (
    <section id="quote" className="et-section bg-white" data-testid={`${testIdPrefix}-section`}>
      <div className="et-container">
        <SectionHeading eyebrow={eyebrow} title={title} subtitle={subtitle} />
        <div className="mt-10 max-w-2xl mx-auto">
          <Reveal>
            <LeadForm source="quote" testIdPrefix={testIdPrefix} defaultService={service} />
          </Reveal>
        </div>
      </div>
    </section>
  );
};
